import { ApiParameters } from './api-parameters';
import { ApiGetRequest } from './api-get-request';

export class TicketInstanceRequest extends ApiGetRequest
{
    public constructor(ticketNumber: number, webapiBasepath: string)
    {
        const parameters = new ApiParameters()
            .addQueryParameter('ticketnumber', ticketNumber);

        super('ticketinstance', parameters, null, webapiBasepath);
    }
}
